
import { computed } from '@nuxtjs/composition-api';
import get from 'lodash/fp/get.js'

export default {
  name: 'TlmChip',
  props: {
    variant: {
      type: String,
      default: '',
      required: true
    }
  },
  setup (props) {
    const variantAttrs = computed(() => {
      const commonClass =
        'tlm-chip tlm-chip--' + props.variant + ' font-weight-bold '

      const variants = {
        'comp-yellow': {
          color: 'warning lighten-1',
          class: commonClass + 'quaternary--text',
          small: true
        },
        'comp-pink': {
          color: 'primary',
          class: commonClass + 'secondary--text',
          small: true
        },
        'comp-cyan': {
          color: 'info',
          class: commonClass + 'primary--text',
          small: true
        },
        info: {
          color: 'info',
          class: commonClass + 'primary--text',
          small: true
        },
        gray: {
          color: 'gray',
          class: commonClass + 'black--text',
          outlined: true,
          small: true
        }
      }

      return { ...get(props.variant)(variants) }
    })
    return {
      variantAttrs
    }
  }
}
